/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_DescInputs */

const en_options_metrics_desc = /** @type {(inputs: Options_Metrics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize how event metrics are calculated and displayed throughout the editor.`)
};

const fr_options_metrics_desc = /** @type {(inputs: Options_Metrics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize how event metrics are calculated and displayed throughout the editor.`)
};

const de_options_metrics_desc = /** @type {(inputs: Options_Metrics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize how event metrics are calculated and displayed throughout the editor.`)
};

const it_options_metrics_desc = /** @type {(inputs: Options_Metrics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize how event metrics are calculated and displayed throughout the editor.`)
};

const ru_options_metrics_desc = /** @type {(inputs: Options_Metrics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize how event metrics are calculated and displayed throughout the editor.`)
};

const es_options_metrics_desc = /** @type {(inputs: Options_Metrics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize how event metrics are calculated and displayed throughout the editor.`)
};

const zh_cn2_options_metrics_desc = /** @type {(inputs: Options_Metrics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize how event metrics are calculated and displayed throughout the editor.`)
};

const ja_options_metrics_desc = /** @type {(inputs: Options_Metrics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize how event metrics are calculated and displayed throughout the editor.`)
};

const hi_options_metrics_desc = /** @type {(inputs: Options_Metrics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize how event metrics are calculated and displayed throughout the editor.`)
};

const pt_pt2_options_metrics_desc = /** @type {(inputs: Options_Metrics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize how event metrics are calculated and displayed throughout the editor.`)
};

/**
* | output |
* | --- |
* | "Customize how event metrics are calculated and displayed throughout the editor." |
*
* @param {Options_Metrics_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_desc = /** @type {((inputs?: Options_Metrics_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_desc(inputs)
	if (locale === "de") return de_options_metrics_desc(inputs)
	if (locale === "it") return it_options_metrics_desc(inputs)
	if (locale === "ru") return ru_options_metrics_desc(inputs)
	if (locale === "es") return es_options_metrics_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_desc(inputs)
	if (locale === "ja") return ja_options_metrics_desc(inputs)
	if (locale === "hi") return hi_options_metrics_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_desc(inputs)
	return en_options_metrics_desc(inputs)
});